import { render, staticRenderFns } from "./VFiltersPanel.vue?vue&type=template&id=f413cb26&"
import script from "./VFiltersPanel.vue?vue&type=script&lang=ts&"
export * from "./VFiltersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./VFiltersPanel.vue?vue&type=style&index=0&id=f413cb26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports